export default __webpack_public_path__ + "static/media/manzil_carousel3-mobile.png";